import * as yup from "yup";

const parseFormattedNumber = (value) => {
  if (value === "" || value === null || value === undefined) return undefined;
  const cleaned = String(value).replace(/,/g, "");
  if (cleaned === "" || cleaned === ".") return undefined;
  const num = parseFloat(cleaned);
  return isNaN(num) ? NaN : num;
};

const formattedNumber = (requiredMessage) =>
  yup
    .number()
    .transform((_, originalValue) => parseFormattedNumber(originalValue))
    .typeError("Enter a valid number")
    .required(requiredMessage);

export const createWaybillSchema = yup.object({
  amount: formattedNumber("Amount is required"),
  quantity: formattedNumber("Quantity is required"),
  aggregatorId: yup.string().required("Aggregator is required"),
  recyclerId: yup.string().required("Recycler is required"),
  transactionDate: yup.string().required("Recycler is required"),
  file: yup.string().nullable(true),
});
export const createWaybillSchemaTwo = yup.object({
  amount: formattedNumber("Amount is required"),
  quantity: formattedNumber("Quantity is required"),
  aggregatorId: yup.string(),
  recyclerId: yup.string().required("Recycler is required"),
  transactionDate: yup.string().required("Recycler is required"),
  file: yup.string().nullable(true),
});
